import React, { useState } from 'react';
import { Modal, Space, Alert, Input } from 'antd';
import { useSelector } from 'react-redux';
import { formatPrice } from '../../../lib/utils';


const { TextArea } = Input;

const NovedadModal = ({ visible, onCancel, onConfirm, diferencia }) => {
  const [localNovedad, setLocalNovedad] = useState('');
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  const handleConfirm = () => {
    onConfirm(localNovedad);
    setLocalNovedad('');
  };

  return (
    <Modal
      title="Registrar Novedad"
      open={visible}
      onCancel={() => {
        setLocalNovedad('');
        onCancel();
      }}
      onOk={handleConfirm}
      okButtonProps={{ disabled: !localNovedad }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          message={`Diferencia detectada: ${formatPrice(Math.abs(diferencia), signoMoneda)}`}
          type="warning"
          showIcon
        />
        <TextArea
          rows={4}
          value={localNovedad}
          onChange={(e) => setLocalNovedad(e.target.value)}
          placeholder="Escriba la novedad aquí..."
        />
      </Space>
    </Modal>
  );
};

export default NovedadModal;